import { render } from "./Budget.vue?vue&type=template&id=b7e2b9b0&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import "./Budget.vue?vue&type=style&index=0&id=b7e2b9b0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7e2b9b0"]])

export default __exports__